export default __webpack_public_path__ + "static/media/wallet-connect.a3ef0249.svg";